import { createSlice } from '@reduxjs/toolkit';

const charactersSlice = createSlice({
  name: 'characters',
  initialState: {},
  reducers: {},
});

export default charactersSlice.reducer;
